/* eslint-disable react-native/no-inline-styles */

import React, { useState } from 'react';
import { Dimensions, ScrollView, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { formatISO, addDays, endOfDay, startOfDay } from 'date-fns';
import Toast from 'react-native-toast-message';
import PropTypes from 'prop-types';

import ModalFull from '@components/modal/ModalFull';
import * as Layout from '@components/screen/Layout';
import SociollaText from '@components/sociolla/SociollaText';
import DatePicker from '@components/form/DatePicker';
import Button from '@components/form/Button';

import { isWeb, isMobileWeb, isAndroid } from '@global/screens';
import Colors from '@global/colors';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';
import { downloadFile } from '@global/helpers';
import { MsOrder } from '@api/ms-order';

const dimension = Dimensions.get('screen');

const defaultProps = {
  show: false,
};

const propTypes = {
  show: PropTypes.bool,
};

const ModalPromotionRuleExport = ({ show }) => {
  const dispatch = useDispatch();

  const [filterExport, setFilterExport] = useState({
    from_date: '',
    to_date: '',
  });

  const handleExport = async () => {
    if (!filterExport.from_date || !filterExport.to_date) {
      dispatch(
        showAlert({
          show: true,
          title: 'Error',
          description: 'Filter date must be filled',
          isConfirm: false,
        }),
      );
      return;
    }
    const payload = {
      promotion_date: {
        $gte: filterExport.from_date,
        $lte: filterExport.to_date,
      },
    };

    try {
      const exportData = await MsOrder.exportPromotionRules(payload);
      if (exportData?.data?.data) {
        downloadFile(exportData.data.data, `promotion-rules`);
        Toast.show({
          text1: 'Export in progress, the result will be sent to your email.',
          type: 'success',
        });
      } else {
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
    dispatch(
      showPopup({
        name: 'showPromotionRuleExport',
        value: false,
      }),
    );
  };

  return (
    <ModalFull
      title="Export Promotion Rules"
      noTranslate={true}
      show={show}
      onClose={() =>
        dispatch(
          showPopup({
            name: 'showPromotionRuleExport',
            value: false,
          }),
        )
      }>
      <View
        style={{
          height: isWeb
            ? 'calc(100vh - 150px)'
            : dimension.height - (isAndroid ? 140 : 110),
        }}>
        <ScrollView contentContainerStyle={{ width: '100%' }}>
          <Layout.FormWrapper style={{ padding: 15, height: '100%' }}>
            <Layout.FormGroup lastItem>
              <SociollaText style={{ fontSize: 13, marginBottom: 10 }}>
                Date
              </SociollaText>
              <View
                style={{
                  width: '100%',
                  flexDirection: isWeb ? 'row' : 'column',
                  justifyContent: 'space-between',
                }}>
                <DatePicker
                  label="Start Date"
                  name="created_at"
                  style={{ width: isWeb ? '49%' : '100%' }}
                  value={filterExport.from_date}
                  onChange={(value) => {
                    setFilterExport({
                      ...filterExport,
                      from_date: formatISO(startOfDay(value)),
                    });
                  }}
                />
                <DatePicker
                  label="End Date"
                  name="created_at"
                  style={{ width: isWeb ? '49%' : '100%' }}
                  value={filterExport.to_date}
                  disableBeforeDate={
                    filterExport.from_date
                      ? filterExport.from_date
                      : addDays(new Date(), 1)
                  }
                  onChange={(value) => {
                    setFilterExport({
                      ...filterExport,
                      to_date: formatISO(endOfDay(value)),
                    });
                  }}
                />
              </View>
            </Layout.FormGroup>
          </Layout.FormWrapper>
        </ScrollView>
        <View
          style={{
            width: '100%',
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: isWeb ? 'end' : 'space-between',
            paddingVertical: isWeb ? 20 : 15,
            paddingHorizontal: isWeb ? 20 : 15,
            backgroundColor: Colors.white,
            ...(!isWeb
              ? {
                  position: isMobileWeb ? 'fixed' : 'absolute',
                  bottom: 0,
                  right: 0,
                  left: 0,
                }
              : {}),
          }}>
          <Button
            rounded={true}
            type="primary"
            buttonStyle={{
              width: isWeb
                ? 100
                : dimension.width / 2 - (isMobileWeb ? 20 : 25),
              backgroundColor: Colors.white,
              marginRight: 10,
            }}
            title={
              <SociollaText type="medium" style={{ fontSize: 14 }}>
                Cancel
              </SociollaText>
            }
            onPress={() =>
              dispatch(
                showPopup({
                  name: 'showPromotionRuleExport',
                  value: false,
                }),
              )
            }
          />
          <Button
            rounded={true}
            type="primary"
            buttonStyle={{
              width: isWeb
                ? 100
                : dimension.width / 2 - (isMobileWeb ? 20 : 25),
            }}
            disabledStyle={{ width: 90 }}
            title={
              <SociollaText
                type="medium"
                style={{ fontSize: 14, color: Colors.white }}>
                Export
              </SociollaText>
            }
            onPress={handleExport}
          />
        </View>
      </View>
    </ModalFull>
  );
};

ModalPromotionRuleExport.propTypes = propTypes;
ModalPromotionRuleExport.defaultProps = defaultProps;

export default ModalPromotionRuleExport;
